<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-add-planning"
            @hidden="resetModal">

            <div class="container wrap-form-create-update-chapter">
                <h4>
                    <strong>{{ getNameTitle }}</strong>
                </h4>
                <div class="row">
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="item item__key input-custom-icon">
                                    <input v-model="paramQueryData.keyword" v-debounce="300" type="text"
                                        placeholder="Tìm kiếm bài giảng điện tử"
                                        class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                                    <i class="icon-search font-size-16 primary-color"></i>
                                </div>
                            </div>

                        </div>
                        <div class="row margin-top-10">
                            <div class="col-md-6">
                                <b-form-select v-model="paramQueryData.classId" :options="listDataClass"
                                    class="">
                                </b-form-select>
                            </div>
                            <div class="col-md-6">
                                <b-form-select v-model="paramQueryData.subjectId" :options="listDataSubject"
                                    class="">
                                </b-form-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 margin-top-10">
                                <b-form-select v-model="paramQueryData.bookTypeId" :options="listBookType"
                                    class="">
                                </b-form-select>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6">
                        <b-form id="form-create-update-chapter" @submit.prevent="handleSave">
                            <div class="row form-group pb-2">
                                <div class="col-md-12">
                                    <div class="login-modal__form__item display-block">
                                        <label for="name">Chọn bài giảng điện tử:</label>
                                        <div class="tittle-list-lesson">Danh sách bài giảng điện tử đang công khai</div>
                                        <div class="wrapper-list">

                                            <b-form-checkbox-group id="listDataLesson" v-model="listDataLesson"
                                                v-for="item in listDataElectronicLecture" stacked name="listDataLesson"
                                                >
                                                <b-form-checkbox :value="item.value"> <router-link :to="{
                path: '/kho-bai-giang/bai-giang-dien-tu', query: {
                    id:
                        item.value, name: item.text
                }
            }" target="_blank" style="color: black;">
                                                        {{ item.text }}
                                                    </router-link></b-form-checkbox>
                                            </b-form-checkbox-group>


                                        </div>
                                        <span class="error display-block color-err font-size-14 text-left"
                                            v-if="!$v.listDataLesson.required && submitted">
                                            Vui lòng chọn bài giảng điện tử
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form_action display-flex justity-content-space-between">
                                <button type="button"
                                    class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                                    :disabled="isLoading" @click="handleHideModal">
                                    Hủy
                                </button>
                                <button type="submit"
                                    class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                                    :disabled="isDisableButton">
                                    Thêm mới
                                </button>
                            </div>
                        </b-form>
                    </div>
                </div>

            </div>

        </b-modal>
    </div>
</template>
<script>
import { getAllTypeFilter, getAllClassFilter } from './../../../_api/'
import { required } from 'vuelidate/lib/validators';
import { getListElectronicLectureByCurrentUser } from './../../../_api/LessonClassSchoolServices'
import { saveLessonPlaningClassSchool } from './../../../_api/lessonPlaningClassSchool'
export default {
    props: {

    },
    watch: {
        'paramQueryData.keyword': 'getListElectronicLecture',
        'paramQueryData.classId': 'getListElectronicLecture',
        'paramQueryData.subjectId': 'getListElectronicLecture',
        'paramQueryData.bookTypeId': 'getListElectronicLecture',
    },
    data() {
        return {
            isDisableButton:false,
            confirmActive: {},
            submitted: false,
            isLoading: false,
            listDataElectronicLecture: [

            ],
            lessonPlaningId: 0,
            listDataLesson: [],
            paramQueryData: {
                id: 0,
                keyword: '',
                classId: 0,
                subjectId: 0,
                bookTypeId: 0
            },
            listDataSubject: [],
            listDataClass: [],
            listBookType: [{value:0,text:'Tất cả bộ sách'}]
            // form: {
            //     id: 0,
            //     name: '',
            // }
        }
    },
    validations() {
        return {
            listDataLesson: {
                required
            }
            // form: {
            //     name: {
            //         required
            //     },
            // }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle() {
            return 'Thêm bài giảng điện tử'
        }
    },
    mounted() {
        this.lessonPlaningId = this.paramQueryData.id = this.$route.query.id
        // if(this.chapterId >0){
        //     //get detail
        //     this.getDetailChapterClassSchool()
        // }
        this.handleShowModal()
        this.getListElectronicLecture()
        this.getTypesFilter()
        this.GetAllClass()

    },
    methods: {
        getTypesFilter() {
            let self = this
            self.listDataSubject = [{value:0,text:'Tất cả môn'}]
            getAllTypeFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }

                    for (let i = 0; i < res.data.ltsBookType.length; i++) {
                        const item = res.data.ltsBookType[i];
                        self.listBookType.push({ value: item.bookGroupId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            self.listDataClass = [{value:0,text:'Tất cả lớp'}]
            getAllClassFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        },
        getListElectronicLecture() {
            this.listDataElectronicLecture = []
            getListElectronicLectureByCurrentUser(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listDataElectronicLecture.push({ value: item.id, text: item.name })
                    }
                }
            })
            console.log(this.listDataElectronicLecture)
        },
        getDetailChapterClassSchool() {
            let self = this
            // getDetail(this.chapterId).then(res => {
            //     if (res && res.data && !res.errors) {
            //         self.form = {
            //             id:res.data.id,
            //             lessonClassSchoolId: res.data.lessonClassSchoolId,
            //             name: res.data.name,
            //         }
            //     }
            // })
        },
        handleSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                self.isDisableButton = true
                saveLessonPlaningClassSchool({ lessonPlaningId: this.lessonPlaningId, listId: this.listDataLesson }).then(res => {
                    if (res && res.data && !res.errors) {
                        self.$toast.success('Thêm mới bài giảng điện tử thành công')

                        self.handleDone()
                    }
                    self.isDisableButton = false
                })
            }
        },
        resetModal() {
            this.submitted = false
            // this.form = {
            //     id: 0,
            //     name: ''
            // }
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-add-planning'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-add-planning'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-add-planning'].show()
        },
    }
}
</script>
<style lang="scss" scoped>
.margin-top-10 {
    margin-top: 10px;
}

.wrap-form-create-update-chapter {
    background-color: white;
}

.wrapper-list {
    max-height: 150px;
    overflow: auto;
    background: #e5e5e5;
    border-radius: 10px;
    padding: 5px;
}

.justify-content-space-between {
    justify-content: space-between
}

.tittle-list-lesson {
    color: #f92c30;
    text-align: center;
    margin-bottom: 5px;
}
</style>
